import { useEffect, useState } from "react";
import toast from "react-hot-toast";
import { BiSolidEdit, BiSolidTrash } from "react-icons/bi";
import { Button, Card, Spinner, Table } from "reactstrap";
import { deleteDocument, getAllOfCollection } from "../../firebase/utility";
import GeneralButton from "../button/GeneralButton";
import NotFoundDataUI from "../cards/NotFoundDataUI";
import AddNewUsAddressModal from "../modals/AddNewUsAddressModal";
import DeleteModal from "../modals/DeleteModal";

const USAddressesTable = () => {
  const [addresses, setAddresses] = useState([]);
  const [loading, setLoading] = useState(true);

  // Modals
  const [createModal, setCreateModal] = useState(false);
  const toggleCreateModal = () => setCreateModal(!createModal);

  const [deleteModal, setDeleteModal] = useState(false);
  const [deleteId, setDeleteId] = useState(null);
  const toggleDeleteModal = () => setDeleteModal(!deleteModal);

  const [updateModal, setUpdateModal] = useState(false);
  const [updateData, setUpdateData] = useState(null);
  const toggleUpdateModal = () => setUpdateModal(!updateModal);

  const fetchAddresses = async () => {
    setLoading(true);
    try {
      const data = await getAllOfCollection("USAddresses");
      setAddresses(data || []);
    } catch (err) {
      toast.error("Failed to fetch US Addresses.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchAddresses();
  }, []);

  const handleDelete = async () => {
    if (!deleteId) return;
    try {
      await deleteDocument("USAddresses", deleteId);
      toast.success("Address deleted successfully");
      fetchAddresses();
    } catch (err) {
      toast.error("Error deleting address");
    } finally {
      toggleDeleteModal();
    }
  };

  return (
    <>
      <AddNewUsAddressModal
        modal={createModal}
        toggle={toggleCreateModal}
        refreshData={fetchAddresses}
        isUpdate={false}
      />
      {updateData && (
        <AddNewUsAddressModal
          modal={updateModal}
          toggle={toggleUpdateModal}
          refreshData={fetchAddresses}
          isUpdate={updateData}
        />
      )}
      <DeleteModal
        modal={deleteModal}
        toggle={toggleDeleteModal}
        handleDelete={handleDelete}
      />

      <div className="d-flex justify-content-between align-items-center mb-4 mt-4 search-input-wrapper">
        <h5 className="fw-bold mb-0">Addresses (Receiving Locations)</h5>
        <div>
          <GeneralButton
            title={"Add New Address"}
            className={"create-user-btn text-white shadow-sm px-4"}
            handleClick={toggleCreateModal}
          />
        </div>
      </div>

      <Card className="border-0 shadow-sm p-3">
        {loading ? (
          <div className="d-flex justify-content-center py-5">
            <Spinner color="primary" />
          </div>
        ) : addresses.length > 0 ? (
          <Table responsive hover bordered className="mb-0" style={{ fontSize: "14px" }}>
            <thead>
              <tr style={{ backgroundColor: "#00509d", color: "white" }}>
                <th className="text-center" style={{ borderBottom: "none" }}>Company</th>
                <th className="text-center" style={{ borderBottom: "none" }}>Contact Name</th>
                <th className="text-center" style={{ borderBottom: "none" }}>Address</th>
                <th className="text-center" style={{ borderBottom: "none" }}>Contact Info</th>
                <th className="text-center" style={{ borderBottom: "none" }}>QB ID</th>
                <th className="text-center" style={{ borderBottom: "none" }}>Action</th>
              </tr>
            </thead>
            <tbody>
              {addresses.map((row, index) => (
                <tr key={index} className="align-middle">
                  <td className="text-center fw-bold">{row.company}</td>
                  <td className="text-center">{row.first_name} {row.last_name}</td>
                  <td className="text-center">
                    {row.address_1} {row.address_2 && `, ${row.address_2}`}<br />
                    {row.city}, {row.state} {row.postcode}
                  </td>
                  <td className="text-center">
                    <div>{row.email}</div>
                    <div className="text-muted small">{row.phone}</div>
                  </td>
                  <td className="text-center">{row.quickbooks_id || "-"}</td>
                  <td className="text-center">
                    <div className="d-flex justify-content-center gap-2">
                      <Button
                        color="link"
                        className="p-1 border-0"
                        onClick={() => {
                          setUpdateData(row);
                          toggleUpdateModal();
                        }}
                      >
                        <BiSolidEdit className="text-primary" size={18} />
                      </Button>
                      <Button
                        color="link"
                        className="p-1 border-0"
                        onClick={() => {
                          setDeleteId(row._id || row.id);
                          toggleDeleteModal();
                        }}
                      >
                        <BiSolidTrash className="text-danger" size={18} />
                      </Button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        ) : (
          <NotFoundDataUI message="No US Addresses found" />
        )}
      </Card>
    </>
  );
};

export default USAddressesTable;
